<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="6" lg="3">
              <el-text-field
                label="Paslaugos kodas"
                disabled
                v-model="code"
                :maxlength="20"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="6" lg="3">
              <el-text-field
                label="PASIS kodas"
                :readonly="modeReadonly"
                v-model="formData.pasis_code"
                :disabled="childComponent || wasActivated"
                :maxlength="20"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="6">
              <el-autocomplete
                required
                :items="enumsClassifiers.serviceType"
                :readonly="modeReadonly"
                enums
                itemvalue="value"
                itemtext="text"
                label="Paslaugos tipas"
                v-model="formData.type"
              />
            </v-col>
            <v-col cols="6">
              <el-autocomplete
                :items="faPermissions"
                :readonly="modeReadonly"
                itemvalue="value"
                itemtext="text"
                label="FA suteikiama teisė"
                v-model="formData.ipas_fa_permission_id"
              />
            </v-col>
            <v-col cols="6">
              <el-autocomplete
                :items="jaPermissions"
                :readonly="modeReadonly"
                itemvalue="value"
                itemtext="text"
                label="JA suteikiama teisė"
                v-model="formData.ipas_ja_permission_id"
              />
            </v-col>
            <v-col class="pb-0" cols="12" >
              <el-autocomplete
                required
                :items="enumsClassifiers.whoMayConsitute"
                :readonly="modeReadonly"
                enums
                longText
                itemvalue="value"
                itemtext="text"
                label="Įgaliojimą gali sudaryti"
                v-model="formData.who_may_consitute"
                :disabled="childComponent || wasActivated"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <el-textarea
                label="Paslaugos pavadinimas (LT)"
                v-model="formData.title_lt"
                :readonly="modeReadonly"
                :maxlength="1000"
                required
                :disabled="wasActivated"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <el-textarea
                required
                label="Paslaugos pavadinimas (EN)"
                v-model="formData.title_en"
                :readonly="modeReadonly"
                :maxlength="1000"
                :disabled="wasActivated"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <el-textarea
                label="Trumpas paslaugos aprašymas administratoriui"
                v-model="formData.short_description"
                :readonly="modeReadonly"
                :maxlength="2000"
              />
            </v-col>
            <v-col v-if="formData.parent_id" class="pb-0" cols="12" md="6">
              <!-- <el-autocomplete
                :items="classifiers.action"
                disabled
                longText
                itemvalue="value"
                itemtext="text"
                label="Tėvinė paslauga"
                v-model="formData.parent_id"
              /> -->
               <el-textarea
                disabled
                label="Tėvinė paslauga"
                v-model="formData.parent_title"
                :readonly="modeReadonly"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="6">
              <el-autocomplete
                :items="getSectorItems"
                :disabled="disableSector"
                enums
                :required="disableSector ? false : true"
                itemvalue="value"
                itemtext="text"
                label="Kliento teikiama paslauga"
                v-model="formData.sector"
                validateKey="sector"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <v-row class="service-institution-row">
                 <v-col class="pt-0 pb-3" cols="12" md="12">
              <el-radio-group
                style="width: fit-content;"
                @change="onInstitutionChange()"
                v-model="formData.provider_type"
                :items="customServices"
                required
                :disabled="childComponent || wasActivated"
              >
              </el-radio-group>
            </v-col>
            <template v-if="showCustomAddProvider" >
                <v-col
                  style="margin-top: 0.5rem"
                  class="pb-0"
                  cols="12"
                  md="12"
                >
                  <el-button
                    v-if="showInstitutionBtn"
                    class="mb-5"
                    color="primary"
                    :icon="newInstitutionIcon"
                    :title="newInstitutionTitle"
                    :loading="loading"
                    @click.native.stop="newInstitution()"
                  />
                </v-col>
                <template v-if="showInstitutionData">
                  <v-col class="pb-0" cols="12" md="6" lg="3">
                    <el-textarea
                      label="Juridinio asmens kodas"
                      disabled
                      v-model="institution.code"
                    />
                  </v-col>
                  <v-col class="pb-0" cols="12" md="4">
                    <el-textarea
                      label="Pavadinimas"
                      disabled
                      v-model="institution.fullname"
                    />
                  </v-col>
                  <v-col class="pb-0" cols="12" md="5">
                    <el-textarea
                      label="Kita informacija"
                      disabled
                      v-model="institution.other_info"
                    />
                  </v-col>
                </template>
                </template>
              </v-row>
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <el-textarea
                autocomplete="off"
                label="Paslaugos numatytasis aprašymas (LT)"
                type="text"
                :readonly="modeReadonly"
                v-model="formData.default_description_lt"
                :maxlength="2000"
              />
            </v-col>
            <v-col class="pb-0" cols="12" md="12">
              <el-textarea
                autocomplete="off"
                label="Paslaugos numatytasis aprašymas (EN)"
                type="text"
                :readonly="modeReadonly"
                v-model="formData.default_description_en"
                :maxlength="2000"
              />
            </v-col>
            <v-col class="pt-0" cols="12" md="12">
              <el-checkbox
                class="my-0"
                style="width: fit-content;"
                label="Leisti redaguoti numatytajį paslaugos aprašymą"
                v-model="formData.default_description_editable"
              >
              </el-checkbox>
            </v-col>
            <v-col class="pb-0" cols="12" md="6">
              <el-autocomplete
                :items="enumsClassifiers.digitalService"
                enums
                required
                itemvalue="value"
                itemtext="text"
                label="El. paslauga"
                :readonly="modeReadonly"
                v-model="formData.digital_service"
              />
            </v-col>
            <v-col style="position: relative;" class="pb-0" cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja nuo"
                required
                :disabled="disableValidFromInput"
                v-model="formData.valid_from"
              />
              <span class="valid-from-msg">{{showValidFormMsg}}</span>
            </v-col>
            <v-col class="pb-0" cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja iki"
                :afterDate="formData.valid_from"
                :futureDates="true"
                :readonly="modeReadonly"
                v-model="formData.valid_to"
              />
            </v-col>
            <v-col class="pt-4" cols="12" md="12" lg="6">
              <el-checkbox
                class="my-0"
                style="width: fit-content;"
                label="Įgaliotiniams draudžiamas „Veikimas kartu“"
                :disabled="childComponent"
                v-model="formData.rep_cannot_act_together"
              >
              </el-checkbox>
              <el-checkbox
                class="my-0"
                style="width: fit-content;"
                label="Draudžiama pridėti daugiau nei vieną įgaliotinį"
                :disabled="childComponent"
                v-model="formData.single_representative_only"
              >
              </el-checkbox>
              <el-checkbox
                class="my-0"
                style="width: fit-content;"
                label="Reikalingas pasirašymas kvalifikuotu el. parašu"
                v-model="formData.signature_required"
              >
              </el-checkbox>
              <el-checkbox
                class="my-0"
                style="width: fit-content;"
                label="Tik notarinis"
                v-model="formData.notarial_only"
                :disabled="childComponent || wasActivated || cannotConsitute"
              >
              </el-checkbox>
              <el-checkbox
                class="my-0"
                style="width: fit-content;"
                label="Supaprastintas"
                v-model="formData.simplified"
              >
              </el-checkbox>
              <el-checkbox
                class="my-0"
                style="width: fit-content;"
                label="Prokūros teisė"
                v-model="formData.procuration_law"
                :disabled="childComponent || wasActivated"
              >
              </el-checkbox>
              <el-checkbox
                class="my-0"
                style="width: fit-content;"
                label="Veiksmas"
                v-model="formData.is_action"
              >
              </el-checkbox>
              <el-checkbox
                class="my-0"
                style="width: fit-content;"
                label="Paslaugos aktyvavimas"
                v-model="formData.is_active"
                :disabled="childComponentActivation"
              >
              </el-checkbox>
            </v-col>
            <v-col v-if="!fromImport" cols="12" md="12" lg="6">
              <v-row>
                <v-col v-if="!fromImport" style="display: flex;" class="pt-4" cols="12">
                  <el-text-field
                    label="IS identifikatorius"
                    v-model="formData.is_identificator"
                    :maxlength="20"
                  />
                  <el-button
                    class="ml-1"
                    title="Paieška"
                    :loading="loading"
                    color="primary"
                    @click.native.stop="callSearchIsIdentificatorModal()"
                  />
                </v-col>
                <v-col class="pb-0" cols="12">
                  <el-autocomplete
                    :items="this.actionExtraFieldSetsList"
                    direct
                    itemvalue="value"
                    itemtext="text"
                    label="Papildomų laukų rinkinys"
                    v-model="formData.action_extra_field_set_id"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col v-if="!fromImport" class="pt-4" cols="12" md="12" lg="6">
              <el-list-select
                label="NIRVAR sritys"
                sub-label="Pridėtos sritys"
                :items="classifiers.nirvar"
                v-model="formData.nirvars"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <template v-if="fromImport">
                      <el-button
                class="mr-1"
                color="secondary"
                icon="atšaukti"
                title="Atšaukti"
                @click.native.stop="importBack()"
                :loading="loading"
              />
              <el-button
                v-if="!modeReadonly"
                title="Išsaugoti"
                :loading="loading"
                @click.native="saveImportData()"
                color="primary"
                icon="išsaugoti"
              />
            </template>
             <template v-else>
              <el-button
                class="mr-1"
                color="secondary"
                icon="atšaukti"
                title="Atšaukti"
                @click.native.stop="back()"
                :loading="loading"
              />
              <el-button
                v-if="!modeReadonly"
                title="Išsaugoti"
                :loading="loading"
                @click.native="saveData()"
                color="primary"
                icon="išsaugoti"
              />
             </template>
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
    <!-- duplicate modal -->
    <v-dialog
      v-model="showDuplicateModal"
      persistent
      max-width="800px"
    >
      <el-overlay-loading :loading="loading" />
      <v-card class="modalCard">
        <v-card-title class="modalTitle pt-2 pb-1">
          <h3 style="word-break: break-word">{{ 'Paslaugos dublio kūrimas' }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click.native.stop="closeDuplicateModal()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="pb-4 pt-0" />
        <v-card-text style="text-align: center" class="pt-3 pb-2">
          <div class="import-modal-div">
          <template v-for="(item, index) in duplicateModalData.errors" >
            <li :key="index"> {{ item }}</li>
          </template>
        </div>
        </v-card-text>
        <v-card-actions class="modalActions">
          <v-row style="text-align: right" no-gutters>
            <v-col>
              <el-button
                title="ATŠAUKTI"
                class="mb-2 mr-2"
                :loading="loading"
                @click.native.stop="closeDuplicateModal()"
                color="secondary"
              />
              <el-button
                title="SAUGOTI DUBLĮ"
                class="mb-2 mr-2"
                :loading="loading"
                @click.native.stop="confirmDuplicateModal()"
                color="primary"
              />
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- modal  -->
    <modal-add-person
      v-if="showAddInstitution"
      v-model="showAddInstitution"
      :modalType="modalType"
      :additionalData="institutionsList"
      @addPersonData="addInstitution"
    />
    <modal-search-is-identificator v-if="showSearchModal" @close-modal="closeSearchModal" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import ModalAddPerson from '@/components/modals/ModalAddPerson'
import ModalSearchIsIdentificator from '@/components/modals/ModalSearchIsIdentificator.vue'
import { classifiersGet } from '@/services/classifierService.js'
import Enums from '@/enums'
import moment from 'moment'

export default {
  name: 'AdminServiceForm',
  components: {
    ModalAddPerson,
    ModalSearchIsIdentificator,
  },
  props: {
    fromImport: Boolean,
    importObject: Object,
  },
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      showSearchModal: false,
      pageloading: false,
      loading: false,
      duplicateModalData: {},
      showDuplicateModal: false,
      formData: {
        nirvars: []
      },
      originalFormData: {},
      code: '',
      tempData: {},
      enumsClassifiers: [],
      classifiers: [],
      faPermissions: [],
      jaPermissions: [],
      actionExtraFieldSetsList: [],
      parentInstitutions: [],
      institutionsList: [],
      institution: {},
      modalType: null,
      showAddInstitution: null,
      childComponent: false,
      childComponentActivation: false,
    }
  },
  computed: {
    cannotConsitute(){
      let arr = ['fiz', 'jur', 'fiz-jur']
      if(arr.includes(this.formData.who_may_consitute)){
        this.$set(this.formData, 'notarial_only', false)
        return true
      }
      return false
    },
    getSectorItems(){
      let obj = {
        lt: {...this.enumsClassifiers.sector.lt},
        en: {...this.enumsClassifiers.sector.en}
      }
      let typeArr = []
      switch (this.formData.provider_type) {
        case 'unidentified-physical':
          typeArr = ['fiz']
        break;
        case 'unidentified-juridical':
          typeArr = ['jur-private','jur-public', 'jur-private-public']
        break;
        case 'unidentified-physical-juridical':
          typeArr = ['fiz-jur']
        break;
        case 'amn':
          if(this.institution.type == "JUR"){
            typeArr = ['jur-private','jur-public', 'jur-private-public']
          } else {
            typeArr = ['fiz']
          }
        break;
        default:
        return {lt:{},en:{}};
      }
      Object.keys(obj.lt).map((item) => {
        if(!typeArr.includes(item)){
            delete obj.lt[item]
        }
      })
      Object.keys(obj.en).map((item) => {
        if(!typeArr.includes(item)){
            delete obj.en[item]
        }
      })
      return obj
    },
    disableSector(){
      return !this.formData.provider_type || (this.formData.provider_type == 'amn' && Object.keys(this.institution).length == 0)
    },
    showInstitutionBtn(){
      if(this.wasActivated){
        return false
      } else {
        return !(this.getParentId && !this.parentItem)
      }
    },
    modeReadonly() {
      return false
    },
    // checkDate(){
    //   if(this.formData.valid_from){
    //     return moment(this.formData.valid_from).isBefore(moment())
    //   } else {
    //     return true
    //   }
    // },
    showValidFormMsg(){
      if(this.formData.is_active && moment(this.formData.valid_from).isBefore(moment().subtract(1, 'days')) && !this.wasActivated) {
        return "Paslaugos galioja nuo data yra ankstensė nei šiandienos"
      } else {
        return ""
      }
    },
    disableValidFromInput() {
      if(this.formData.is_active && !this.formData.valid_from && !this.getId){
        this.setValidFrom()
      }
      return this.wasActivated ? true : this.formData.is_active
    },
    showCustomAddProvider() {
      return this.formData.provider_type == 'amn'
    },
    newInstitutionTitle() {
      return this.showInstitutionData
        ? 'Pakeisti instituciją'
        : 'Pridėti instituciją'
    },
    newInstitutionIcon() {
      return this.showInstitutionData ? 'pakeisti' : 'pridėti'
    },
    wasActivated() {
      return this.formData.was_activated == '1'
    },
    parentItem() {
      return this.formData.parent_id === null
    },
    getId() {
      return this.$route.params.id || null
    },
    getParentId() {
      return this.$route.params.parent_id || null
    },
    showInstitutionData() {
      return this.institution && Object.keys(this.institution).length != 0
    },
    getTitle() {
      if (this.fromImport){
        return this.$t(`Redaguoti paslaugą / veiksmą`)
      }
      if (this.getId) {
        return this.$t(`Redaguoti paslaugą / veiksmą`)
      } else {
        return this.$t(`Nauja paslauga / veiksmas`)
      }
    },
    customServices() {
      return [
        {
          label: 'Bet kuris fizinis asmuo',
          value: 'unidentified-physical',
        },
        {
          label: 'Bet kuris juridinis asmuo',
          value: 'unidentified-juridical',
        },
        {
          label: 'Bet kuris fizinis arba juridinis asmuo',
          value: 'unidentified-physical-juridical',
        },
        { label: 'Ieškoti paslaugų teikėjo', value: 'amn' },
      ]
    },
  },
  beforeDestroy() {},
  created() {
    this.loadActionExtraFieldSets()
    if (this.getId || this.getParentId) {
      this.getData()
    } else {
      this.$set(this.formData, 'provider_type', "amn")
      this.$set(this.formData, 'action_extra_field_set_id', '')
      this.getClassifiers()
    }
    if(this.fromImport){
      this.originalFormData = JSON.parse(JSON.stringify(this.importObject))
      this.formData = this.importObject
      this.institution = this.formData.institution;
    }
  },
  methods: {
    callSearchIsIdentificatorModal(){
      this.showSearchModal = true
    },
    closeSearchModal(item){
      if(item){
        this.$set(this.formData, 'is_identificator' , item)
      }
      this.showSearchModal = false
    },
    setValidFrom(){
      this.formData.valid_from = moment().format('YYYY-MM-DD')
    },
     onInstitutionChange() {
      if (this.formData.provider_type != 'amn') {
        this.institution = {}
        this.institutionsList = []
      }
      this.$set(this.formData, 'sector', "")
    },
    addInstitution(item) {
      this.$set(this.formData, 'sector', "")
      this.institutionsList = [item]
      this.institution = item
      this.showAddInstitution = false
    },
    newInstitution() {
      this.modalType = 'institution'
      this.showAddInstitution = true
    },
    back() {
      this.$router.push({ name: 'classifierServices' })
    },
    loadActionExtraFieldSets() {
      this.$axios
        .post(`action-extra-field-sets/list`, {
          page: 1,
          pageSize: 500,
          sort: null,
          sortDesc: [],
          direction: 'asc',
          search: {},
        })
        .then((res) => {
          const rows =
            res.data.action_extra_field_sets ||
            res.data.actionExtraFieldSets ||
            res.data.sets ||
            []
          this.actionExtraFieldSetsList = rows.map((r) => ({
            value: Number(r.id),
            text: `${r.code} – ${r.title}`,
          }))
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
    },
    normalizeActionExtraFieldSetId(formData) {
      const v = formData.action_extra_field_set_id
      if (v === '' || v === undefined || v === null) {
        formData.action_extra_field_set_id = null
      } else {
        formData.action_extra_field_set_id = Number(v)
      }
    },
    applyActionExtraFieldSetIdFromAction(action) {
      const sid = action.action_extra_field_set_id
      this.$set(
        this.formData,
        'action_extra_field_set_id',
        sid != null && sid !== '' ? Number(sid) : ''
      )
    },
    async getClassifiers() {
      this.enumsClassifiers = Enums
      this.loadDefault = true
      let requiredClassifiers = { classifiers: ['ipas_ja_permission', 'ipas_fa_permission'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.jaPermissions = res.data.classifiers.ipas_ja_permission
          this.faPermissions = res.data.classifiers.ipas_fa_permission
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loadDefault = false
        })
      classifiersGet({ classifiers: ['nirvar']})
        .then(res => this.classifiers = res.data.classifiers)
        .catch(err => this.$root.$emit('DATA_ERROR', err))
        .finally()
    },
    setParentTitle(main, formData){
      let text = ``
      if(main){
        let code = formData.code ? `#${formData.code}` : null
        code && (text += ` ${code}`)
        let pasis = formData.pasis_code ? `#${formData.pasis_code}` : null
        pasis && (text += ` ${pasis}`)
        let title = this.$i18n.locale === 'lt' ? (formData.title_lt ? `#${formData.title_lt}` : null) : (formData.title_en ? `#${formData.title_en}` : null)
        title && (text += ` ${title}`)
      } else {
        let code = this.formData.parent.code ? `#${this.formData.parent.code}` : null
        code && (text += ` ${code}`)
        let pasis = this.formData.parent.pasis_code ? `#${this.formData.parent.pasis_code}` : null
        pasis && (text += ` ${pasis}`)
        let title = this.$i18n.locale === 'lt' ? (this.formData.parent.title_lt ? `#${this.formData.parent.title_lt}` : null) : (this.formData.parent.title_en ? `#${this.formData.parent.title_en}` : null)
        title && (text += ` ${title}`)
      }
      this.$set(this.formData, 'parent_title', text)
    },
    setNirvarIds(action) {
      let nirvarIds = [];
      action.nirvars.map((item) => {
        nirvarIds.push(item.id + "")
      })
      this.formData.nirvars = nirvarIds
    },
    async getData() {
      this.pageloading = true
      await this.getClassifiers()

      this.$axios
        .get(`actions/${this.getId || this.getParentId}`)
        .then((res) => {
          if (this.getId) {
            this.formData = res.data.action
            this.applyActionExtraFieldSetIdFromAction(res.data.action)
            this.setNirvarIds(res.data.action)
            this.code = this.formData.code
            this.institution = this.formData.institution
            if(this.formData.parent_id){
              this.setParentTitle()
              this.childComponent = true;
              // this.formData.parent.was_activated == '0' && (this.childComponentActivation = true)
              this.formData.parent.is_active == false  && (this.childComponentActivation = true)
            }
          } else {
            this.formData.parent_id = res.data.action.id.toString()
            this.$set(this.formData, 'ipas_fa_permission_id', res.data.action.ipas_fa_permission_id)
            this.$set(this.formData, 'ipas_ja_permission_id', res.data.action.ipas_ja_permission_id)
            this.$set(this.formData, 'provider_type', res.data.action.provider_type)
            this.$set(this.formData, 'type', res.data.action.type)
            this.$set(this.formData, 'sector', res.data.action.sector)
            this.$set(this.formData, 'default_description_lt', res.data.action.default_description_lt)
            this.$set(this.formData, 'default_description_en', res.data.action.default_description_en)
            this.$set(this.formData, 'default_description_editable', res.data.action.default_description_editable)
            this.$set(this.formData, 'digital_service', res.data.action.digital_service)
            this.$set(this.formData, 'pasis_code', res.data.action.pasis_code)
            this.$set(this.formData, 'who_may_consitute', res.data.action.who_may_consitute)
            this.$set(this.formData, 'notarial_only', res.data.action.notarial_only)
            this.$set(this.formData, 'procuration_law', res.data.action.procuration_law)
            this.$set(this.formData, 'valid_from', res.data.action.valid_from)
            this.$set(this.formData, 'valid_to', res.data.action.valid_to)
            this.$set(this.formData, 'signature_required', res.data.action.signature_required)
            this.$set(this.formData, 'simplified', res.data.action.simplified)
            this.$set(this.formData, 'rep_cannot_act_together', res.data.action.rep_cannot_act_together)
            this.$set(this.formData, 'single_representative_only', res.data.action.single_representative_only)
            this.$set(this.formData, 'is_action', res.data.action.is_action)
            // When creating from parent action, keep set unselected by default.
            this.$set(this.formData, 'action_extra_field_set_id', '')
            this.setNirvarIds(res.data.action)
            res.data.action.is_active == false  && (this.childComponentActivation = true)
            // res.data.action.was_activated == '0' && (this.childComponentActivation = true)
            this.childComponent = true;
            this.setParentTitle(true, res.data.action)
            this.institution = res.data.action.institution
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData(duplicate) {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          if (this.wasActivated) {
            let formData = this.formData
            formData.default_description_editable = !!this.formData.default_description_editable
            formData.signature_required = !!this.formData.signature_required
            this.normalizeActionExtraFieldSetId(formData)
            if(duplicate){
              formData.with_duplicate = true
            }
            let url = `actions/update-active/${formData.id}`
            this.$axios
              .post(url, formData)
              .then((res) => {
                this.$root.$emit('DATA_OK_CODE', '000110')
                this.back()
              })
              .catch((err) => {
                if(err.response.data.only_duplicate_errors){
                  this.duplicateModalData = err.response.data
                  this.showDuplicateModal = true
                } else {
                  err.response.data.fields = {
                    institution_id:  this.$t("Pridėti instituciją"),
                    sector:  this.$t("Kliento teikiama paslauga")
                  }
                  this.$root.$emit('DATA_ERROR', err)
                }
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            let formData = this.formData
            formData.code = this.code
            formData.institution_id = this.institution ? this.institution.amn_id : null
            formData.default_description_editable = !!this.formData.default_description_editable
            formData.signature_required = !!this.formData.signature_required
            this.normalizeActionExtraFieldSetId(formData)
            if(duplicate){
              formData.with_duplicate = true
            }
            let url = `actions`
            this.getId && (formData.id = this.getId)
            this.getParentId && (formData.parent_id = this.getParentId)
            this.$axios
              .post(url, formData)
              .then((res) => {
                this.$root.$emit('DATA_OK_CODE', '000110')
                this.back()
              })
              .catch((err) => {
                if(err.response.data.only_duplicate_errors){
                  this.duplicateModalData = err.response.data
                  this.showDuplicateModal = true
                } else {
                  err.response.data.fields = {
                    institution_id:  this.$t("Pridėti instituciją"),
                    sector:  this.$t("Kliento teikiama paslauga")
                  }
                  this.$root.$emit('DATA_ERROR', err)
                }

              })
              .finally(() => {
                this.loading = false
              })
          }
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    closeDuplicateModal(){
      this.duplicateModalData =  {}
      this.showDuplicateModal = false
    },
    confirmDuplicateModal(){
      this.saveData(true)
      this.closeDuplicateModal()


      // with_duplicate: true

      // const isSave =  this.importModalData.save
      // const elementData = this.elementData
      // this.closeImportModal()
      // if(isSave){
      //   this.saveData(type)
      // } else {
      //   this.getData(elementData, type)
      // }
    },
    importBack(){
      this.formData = this.originalFormData
      this.$emit('back', this.formData)
    },
    saveImportData(){
      this.$validator.validateAll().then((res) => {
      if (res) {
        this.$emit('save')
      } else {
        this.$root.$emit('FORMAT_ERROR')
      }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.valid-from-msg{
  position: absolute;
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
  font-size: 12px;
  top: 3.45rem;
  left: 1.5rem;
}

.import-modal-div{
  border: 1px solid rgba(0, 0, 0, .12);
  border-radius: 5px;
  text-align: left;
  padding: 5px 5px 5px 15px;
  max-height: 300px;
  overflow-y: auto;
}
</style>
